export enum Expression {
  PERCENTAGE = 'percentage',
  ADDITION = 'addition',
  SUBSTRACTION = 'substraction',
  DIVISION = 'division',
  MULTIPLICATION = 'multiplication',
  EXPRESSION = 'expression',
}
